module.exports = __webpack_public_path__ + "static/media/play_black.396177a1.svg";